module.exports = __webpack_public_path__ + "static/media/external_env_3_product_image_2.c2176f54.webp";